import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_snack_10: FaireProductEntity = {
  token: "nyc-snack-10",
  type: "product",
  name: "Dried Fruit Medley",
  brandName: "Upstate Orchards",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/940210bb55e815c99267443067b07e79b14ff31c9575809d622d80d98df35659.webp",
  priceDollars: 12,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/940210bb55e815c99267443067b07e79b14ff31c9575809d622d80d98df35659.webp",
  weight: 0.4,
  dimensions: {
    width: 4,
    height: 6,
    depth: 2,
  },
  description: "Naturally dried fruit medley with no added sugar",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "organic", "healthy"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
